import {Component, OnDestroy, OnInit} from "@angular/core";
import {Field} from "../models/field.model";
import {Subscription} from "rxjs/internal/Subscription";
import {SharedDataService} from "../../../services/shared/shared-data.service";


@Component({
    selector: "tig-form-textarea",
    template: `
    <div
        class="form-group"
        [formGroup]="OBJ_form_group"
        [ngClass]="{'has-error': isInvalid()}">
        <ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
        <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
            <i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
               [tooltip]="tooltipTemplate"
               placement="top"
               triggers="click"
               containerClass="tig-tooltip"
               delay="50"></i>
            <span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
            <div *ngIf="OBJ_field_config.deprecated" class="tig-hint">{{'deprecated'|translate}}</div></label>
        <div class="col-lg-8">
            <textarea
                class="form-control"
                [placeholder]="getLabelName()|translate"
                [formControlName]="OBJ_field_config.name"
                (blur)="setValue($event)"
            >
            </textarea>
			<div class="tig-hint" *ngIf="OBJ_field_config.note">
				<span>{{ OBJ_field_config.note|translate}}</span>
			</div>
            <tig-form-error [OBJ_form_control]="getFormControl()"></tig-form-error>
        </div>
    </div>
  `
})
export class FormTextareaComponent extends Field implements OnInit,OnDestroy
{
	private subscriptions: Subscription[] = [Subscription.EMPTY]

	constructor(private subscription_service: SharedDataService,) {
		super();
	} // end constructor

	ngOnInit(): void {

		if (this.OBJ_field_config.externally_editable) {
			this.subscription_service.createSubject(this.OBJ_field_config.name + "_external");

			this.subscriptions.push(this.subscription_service.getValue(this.OBJ_field_config.name + "_external").subscribe(
				value => {
					// Nur weiter wenn value befuellt ist
					if (value) {
						this.markAsDirtyAndTouched();
						// Setze neuen Wert - sowohl in der Formcontrol als auch in der Config selbst (Anzeige & Abspeicherung)
						super.setValue(value);
						let form_control = this.getFormControl();
						form_control.setValue(value);
					}

				})); // end subscribe
		}

	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions to prevent memory leak
		this.subscriptions.forEach(
			(OBJ_subscription: Subscription) => {
				OBJ_subscription.unsubscribe();
			}
		);
	}

    setValue(event: any) {
        super.setValue(event.target.value);
    }

} // end class FormTextareaComponent
